import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import Sidebar from "components/Siderbar";
import OrderBy from './OrderBy';
import orderIcon from 'images/icons/order-icon.svg';
import style from './style.scss';//NOSONAR

const ShelfHeader = (props) => {
    const {title, quantity} = props;
    const [sticky, setSticky] = useState(false);
    const [orderText, setOrderText] = useState('Ordenar por');

    useEffect(() => {
        if(window){
            window.addEventListener('scroll', scrolling);
        }

        return function cleanup(){
            window.removeEventListener('scroll', scrolling);
        }
    }, []);

    const openFilter = () => {
        PubSub.dispatch('catalog_toogleFilter', { isFilterOpened: true});
    }

    const openFilterOrder = () => {
        PubSub.dispatch('catalog_toogleFilter', { isOrderOpened: true});
    }

    const scrolling = () => {
        const sY = window.scrollY;

        const headerHeight = document.getElementsByTagName('header')[0].offsetHeight - 5;

        if(sY >= headerHeight){
            setSticky(true);
        } else {
            setSticky(false);
        }

    }

    const orderBy = (text) => {
        setOrderText(text);
    }
    
    return (
        <div className={'shelf-header'+ (sticky ? ' sticky' : '')}>
            <div className="shelf-header-title-wrapper">
                {title && <h2 className="shelf-header-title">{title}</h2>}
                {!!quantity && <span className="shelf-header-amount">{quantity} productos</span>}
            </div>
            <div className="shelf-header-options">
                <button className="shelf-filter-mobile-btn" onClick={openFilter}>
                    <i className="font-icn filter"/>
                    Filtrar
                </button>
                <Sidebar filters={props.filters} specifications={props.specifications} filter={props.filter}/>
                <div className="shelf-header-order-by-label" onClick={openFilterOrder}>
                    <i dangerouslySetInnerHTML={{ __html: orderIcon }} className="order-icon-mobile" />
                    <span className="shelf-header-span">{orderText}</span>
                </div>
                <OrderBy order={props.order} orderBy={orderBy} title={title}/>
            </div>
        </div>
    )
}
ShelfHeader.propTypes = {
    order: PropTypes.string,
    quantity: PropTypes.number,
    title: PropTypes.string,
    filters: PropTypes.object,
    specifications: PropTypes.array,
    filter: PropTypes.object,
}
export default ShelfHeader;
